export default "__VITE_ASSET__DQ8x3jW3__"